const initialState = {};

export default function reducer(state = initialState, action) {
  switch (action.type) {
    case 'table.current_set_specification_sets/SET_TABLE_PARAMS':
      return {
        ...state,
        ...action.params,
      };

    case 'table.current_set_specification_sets/LIST_CURRENT_SET_SPECIFICATION_SETS_SUCCESS':
      return {
        ...state,
        data: action.response.data,
        filters: action.response.filters,
        ...action.response.pagination,
      };

    default:
      return state;
  }
}
